import { AccountingPlatform, AccountingPlatformConnectionStatus } from '@melio/javascript-sdk';

const getPreviouslyConnectedAccountingPlatform = (data?: AccountingPlatform[]): AccountingPlatform | undefined =>
  data?.find((ap) => ap.connectionStatus !== AccountingPlatformConnectionStatus.Disconnected);

export const getAvailableToConnectAccountingPlatforms = (data?: AccountingPlatform[]): AccountingPlatform[] => {
  const previouslyConnectedAccountingPlatform = getPreviouslyConnectedAccountingPlatform(data);
  return previouslyConnectedAccountingPlatform ? [previouslyConnectedAccountingPlatform] : data ?? [];
};
